jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };

});
